import {
  DEFAULT_STO_COMPLETION_TIME,
  MIN_RATE_LIMIT_PER_MINUTE,
  MIN_RATE_LIMIT_PER_SECOND,
  MIN_STO_COMPLETION_TIME,
} from 'modules/campaigns/lib/constants';
import { PRIORITY_LEVEL_VALUES } from 'modules/campaigns/editor/constants';
import { MessageMedium, RateLimitUnit } from 'modules/domains/campaign';
import { QuietHours as QuietHoursIcon, AiColor16 as SendTimeOptimizationIcon } from 'ui/icons';

export const STO_SUPPORTED_MEDIUMS = [MessageMedium.Email, MessageMedium.Push];

const STO_COMPLETION_TIME_ERROR_MESSAGE = `Must be between ${MIN_STO_COMPLETION_TIME} and ${DEFAULT_STO_COMPLETION_TIME} hours`;
const RATE_LIMIT_ERROR_MESSAGE_PER_MINUTE = `Must be at least ${MIN_RATE_LIMIT_PER_MINUTE}`;
const RATE_LIMIT_ERROR_MESSAGE_PER_SECOND = `Must be at least ${MIN_RATE_LIMIT_PER_SECOND}`;

export const STO_COMPLETION_TIME_RANGE = {
  min: MIN_STO_COMPLETION_TIME,
  defaultMessage: STO_COMPLETION_TIME_ERROR_MESSAGE,
  max: DEFAULT_STO_COMPLETION_TIME,
};

export const RATE_LIMIT_RANGE_PER_MINUTE = {
  min: MIN_RATE_LIMIT_PER_MINUTE,
  defaultMessage: RATE_LIMIT_ERROR_MESSAGE_PER_MINUTE,
  max: Infinity,
};

export const RATE_LIMIT_RANGE_PER_SECOND = {
  min: MIN_RATE_LIMIT_PER_SECOND,
  defaultMessage: RATE_LIMIT_ERROR_MESSAGE_PER_SECOND,
  max: Infinity,
};

export const RATE_LIMIT_UNIT_OPTIONS = Object.values(RateLimitUnit).map((u) => ({
  id: u,
  value: u,
  label: u,
}));

export const PRIORITY_LEVEL_OPTIONS = Object.entries(PRIORITY_LEVEL_VALUES).map(([key, value]) => ({
  name: key,
  value: `${value}`,
}));

export const SELECTIVE_TARGETING_PLACEHOLDER_OPTIONS = [
  {
    id: 'placeholder-option',
    label: '',
    value: '',
  },
];

export enum OptimizeSectionField {
  DisplayPriority = 'DisplayPriority',
  QuietHours = 'QuietHours',
  SendTimeOptimization = 'SendTimeOptimization',
  SendRateLimit = 'SendRateLimit',
}

export const OPTIMIZE_SECTION_FIELD_LABEL_ICONS_MAPPER = {
  [OptimizeSectionField.QuietHours]: QuietHoursIcon,
  [OptimizeSectionField.SendTimeOptimization]: SendTimeOptimizationIcon,
};

export const SECONDS_IN_DAY = 86400;
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_MINUTE = 60;

export const STO_TOOLTIP_CONTENT = `There’s currently a Send Time Optimization experiment tied to this campaign`;
export const SEND_TIME_TOOLTIP_CONTENT = `This feature is not available when send time experiments are added.`;
